import styled from "@emotion/styled";

export const Title = styled.h2`
  font-size: 22px;
  text-align: center;
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  line-height: 1.25;
  color: ${({ theme }) => theme.colors.secondary.title};

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    font-size: ${({ theme }) => theme.fontSizes.xxl};
  }

  ${props => props.addStyles}
`;
